<template>
  <v-container
    class="pa-0 mt-1 d-flex align-start"
    :style="{ maxWidth: maxWidth + 'px' }"
  >
    <v-card class="rounded-lg" width="100%">
      <v-card-title
        class="primary white--text px-1 pb-3 pt-1 d-flex justify-space-between"
      >
        <div>
          <v-btn icon dark to="/">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="ml-2">Info Desk</span>
        </div>

        <v-btn icon dark to="/profile">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="white rounded-lg card-relative pa-0">
        <v-row no-gutters>
          <v-col cols="10">
            <DeskImages />
            <v-card-title
            style="position:fixed;bottom:10%" class="white--text"
                >Having Problems? Chat with our live support staff!
                <v-btn
                  @click="openInfoChat"
                  class="ml-2"
                  rounded
                  color="primary"
                  >Start Chat
                  <v-icon right>mdi-message-processing-outline</v-icon></v-btn
                >
              </v-card-title>
          </v-col>
          <v-col class="">
            <div class="d-flex justify-center">
              <span class="text-h5">Helpful Links</span>
            </div>
            <v-list dense>
              <v-list-item
                v-for="(link, index) in links"
                :key="index"
                @click="openLink(link)"
                class="text-center"
              >
                <v-list-item-content>
                  <v-list-item-title
                    class="primary--text text-decoration-underline"
                    >{{ link.title }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import DeskImages from './DeskImage'
export default {
  name: "Desk",
  components : {
    DeskImages
  },
  data() {
    return {
      links: [
        { title: "FAQs", to: "", hasLink : true , link : "https://flaacosvirtualconference.com:3334/uploads/files/1605696396033-FLAACOs_User_Manual.pdf" },
        { title: "Auditorium", to: "session" },
        { title: "Vendor Hall", to: "vendor-hall" },
        { title: "Networking Room", to: "networking-room" ,hasPopup : false },
        { title: "Homepage", to: "/" },
      ],
      chat_url: document.location.origin + "/#/info-desk-chat",
    };
  },
  computed: {
    ...mapState("utils", ["maxWidth"]),
  },
  methods: {
    ...mapMutations("attendees", ["setData"]),
    openLink(link){
      if(link.hasPopup){
        this.setData({
          key : 'show_modal',
          data : true
        })
      } else if(link.hasLink){
        this.$helper.openUrl(link.link)
      }else {
        this.$router.push({path : link.to})
      }
    },
    openInfoChat() {
      window.open(
        this.chat_url,
        "info-desk-chat",
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );
    },
  },
};
</script>

<style></style>
